import { Component, OnInit } from '@angular/core';
import { Device } from '@awesome-cordova-plugins/device/ngx';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar } from '@capacitor/status-bar';
import { MenuController, Platform } from '@ionic/angular';
import { parseColor } from '@utils/color';

@Component({
  selector: 'app-root',
  templateUrl: './app-root.component.html',
  styleUrls: ['./app-root.component.scss']
})
export class AppRootComponent implements OnInit {
  constructor(private platform: Platform, private menuController: MenuController, private device: Device) {
    this.platform.ready().then(async () => {
      if (this.platform.is('cordova')) {
        if (this.device.platform === 'Android') {
          StatusBar.setOverlaysWebView({ overlay: false });
          StatusBar.setBackgroundColor({ color: parseColor() });
        }
        SplashScreen.hide();
      } else {
        this.setupBackButtonBehavior();
      }
    });
  }

  protected setupBackButtonBehavior() {
    window.onpopstate = () => {
      if (this.menuController.isOpen()) {
        this.menuController.close();
        return;
      }
    };
  }

  ngOnInit() {}
}
